import { Link } from 'react-router-dom'
import { css, Theme } from '@emotion/react'

const backButtonStyle = (t: Theme) => css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${t.c.bc.text};
  text-decoration: none;
  width: 27px;
  height: 27px;
  border-radius: 8px;
  border: 2px solid #bdbdbd;
  background: #ffffff;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${t.c.ec.shallowGray};
  }
`

const iconStyle = css`
  width: 14px;
  height: 14px;
  fill: currentColor;
`

export type Props = {
  to: string
}

export default function BackButton({ to }: Props) {
  return (
    <Link to={to} css={backButtonStyle}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
        css={iconStyle}
      >
        <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" />
      </svg>
    </Link>
  )
}
